import { defineComponent as _defineComponent } from 'vue'
import IconTrash from '@white-label-icon/icon-trash';
import IconMessage from '../icon-message/icon-message.vue';

interface ManageBookingCancelHeaderProps {
  customText?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'manage-booking-cancel-header',
  props: {
    customText: { default: '' }
  },
  setup(__props: any) {





return { __sfc: true,IconTrash, IconMessage }
}

})